import { categoryHasStockButPageDoesNot } from "../../helpers/categoryHasStockButPageDoesNot";

const categoryPageNumberExceedsAvailableProducts = ({ response }) => {
  const { products, itemCount } = response;

  if (
    categoryHasStockButPageDoesNot({
      itemCount,
      productsLength: products?.length,
    })
  ) {
    const url = new URL(window.location.href);
    url.searchParams.delete("page");

    const safePath = url.pathname.startsWith("/") ? url.pathname : "/";
    const safeSearch = url.search.replace(/[^a-zA-Z0-9=&?_-]/g, "");

    const nextUrl = `${safePath}${safeSearch}`;

    window.location.replace(nextUrl);

    return true;
  }

  return false;
};

export default categoryPageNumberExceedsAvailableProducts;
